module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAASCAYAAACXScT7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABpSURBVHgB5Y7LDYAgEERnwbPezUaxB/WMlVGKpViZWYVkEyDGBpjLfmZeMkCmifeALzle/cyb8Dv1Z3QRIFEWFArTpTQp4ZU2OaVSmiIloKvucEMOO/TjGTO1aepfbFsGftSkSZ1d8vsBpZ0RFigb4qIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/arrow-up-icon.png
// module id = 512
// module chunks = 0